module.exports = __webpack_public_path__ + "img/descartes_institute.ede17be4.png";